import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const {
      target,
      category,
      isActive
    } = payload || {}

    // API /product/list supports: limit, offset, target, category, isActive (string "true"/"false")
    return buildApiUrl(ADMIN_ENDPOINTS.PRODUCTS, {
      queryParams: {
        limit: 200,
        offset: 0,
        target: target || undefined,
        category: category || undefined,
        // API expects string "true"/"false", not boolean
        isActive: isActive !== null && isActive !== undefined ? String(isActive) : undefined,
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch products',
        data: null,
      }
    }

    // /product/list returns { statusCode: 200, count: N, data: [...] }
    const products = Array.isArray(raw.data) ? raw.data : []
    const total = raw.count || products.length

    const formatted = products.map(p => ({
      id: p.id || p._id,
      name: p.name || '—',
      description: p.description || '',
      price: p.price ?? 0,
      currency: p.currency || 'XOF',
      target: p.target || 'rider',
      category: p.category || '',
      stock: p.stock ?? 0,
      image: p.image || null,
      isActive: p.isActive !== false,
      createdAt: p.createdAt,
      updatedAt: p.updatedAt,
    }))

    let finalData = formatted

    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      finalData = finalData.filter(el => {
        return (el.name && el.name.toLowerCase().includes(searchTerm)) ||
               (el.description && el.description.toLowerCase().includes(searchTerm)) ||
               (el.category && el.category.toLowerCase().includes(searchTerm)) ||
               (el.id && el.id.toLowerCase().includes(searchTerm))
      })
    }

    // === Filtres col depuis TableList (target, isActive) ===
    const targetFilter = payload?.target
    if (targetFilter) {
      finalData = finalData.filter(el => el.target === targetFilter)
    }

    // isActive vient de TableList comme string "true"/"false" ou vide
    const isActiveFilter = payload?.isActive
    if (isActiveFilter === 'true' || isActiveFilter === true) {
      finalData = finalData.filter(el => el.isActive === true)
    } else if (isActiveFilter === 'false' || isActiveFilter === false) {
      finalData = finalData.filter(el => el.isActive === false)
    }

    // === Tri dynamique ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey && sortKey !== 'none') {
      const order = sortOrder === 'desc' ? -1 : 1
      finalData = [...finalData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    const isFiltered = searchTerm || targetFilter || isActiveFilter

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = finalData.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: isFiltered ? finalData.length : total,
        result: paginated,
      },
    }
  },
}
